"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _immutable = require("immutable");

var DEFAULTS = {
  accessPassedToast: null,
  commenters: new _immutable.Set(),
  locker: null,
  requestedAccess: false,
  requesters: new _immutable.Set(),
  requestRejected: false
};

var Presence = /*#__PURE__*/function (_Record) {
  (0, _inherits2.default)(Presence, _Record);

  function Presence() {
    (0, _classCallCheck2.default)(this, Presence);
    return (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(Presence).apply(this, arguments));
  }

  (0, _createClass2.default)(Presence, null, [{
    key: "fromJS",
    value: function fromJS(data) {
      var commenters = data.commenters,
          locker = data.locker;
      return new Presence({
        commenters: commenters || new _immutable.Set(),
        locker: locker
      });
    }
  }]);
  return Presence;
}((0, _immutable.Record)(DEFAULTS));

exports.default = Presence;
module.exports = exports.default;